import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrSelect from '../components/FrSelect'

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function Contas_Bancarias() {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboBco, setComboBco] = useState([{ value: '', display: '' }])

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)


      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Contas Bancárias', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Contas Bancárias', 'Inclusao'))
      }

      setComboBco(await api.getComboData('bancos'))

      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/contas_bancarias?pk_cbc=' + query.codigo).then(r => {
          if (r.data[0]) {
            console.log(r.data[0])
            setData(r.data[0])
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'nome_agencia',
      'fk_bco',
      'conta'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (fieldName == 'fk_bco') fieldName = 'Banco'
      if (fieldName == 'nome_agencia') fieldName = 'Descrição'
      if (fieldName == 'conta') fieldName = 'Nº Conta'

      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        let errors = consistData(auxValues)
        console.log(errors.length)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/contas_bancarias/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/contas_bancarias/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'CNPJ':
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Conta Bancária</h3>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='30'
            value={data.nome_agencia || ''}
            onChange={handleChange}
            name="nome_agencia"
            id="nome_agencia"
            color="#528b46"
            label="Descrição"
            variant="outlined"
            size="small"
            required
            style={{ width: 330 }}
          />


          <FrSelect
            value={data.fk_bco || ''}
            onChange={handleChange}
            name="fk_bco"
            id="fk_bco"
            label='Banco'
            data={comboBco}
            style={{ width: 230 }}
          />

          <FrTextInput
            maxLength='10'
            value={data.agencia || ''}
            onChange={handleChange}
            name="agencia"
            id="agencia"
            color="#528b46"
            label="Agência"
            variant="outlined"
            size="small"
            style={{ width: 80 }}
          />

          <FrTextInput
            maxLength='2'
            value={data.dig_agencia || ''}
            onChange={handleChange}
            name="dig_agencia"
            id="dig_agencia"
            color="#528b46"
            label="Dígito"
            variant="outlined"
            size="small"
            style={{ width: 50 }}
          />


          <FrTextInput
            maxLength='10'
            value={data.conta || ''}
            onChange={handleChange}
            name="conta"
            id="conta"
            color="#528b46"
            label="Nº Conta"
            variant="outlined"
            size="small"
            required
            style={{ width: 80 }}
          />

          <FrTextInput
            maxLength='2'
            value={data.dig_conta || ''}
            onChange={handleChange}
            name="dig_conta"
            id="dig_conta"
            color="#528b46"
            label="Dígito"
            variant="outlined"
            size="small"
            style={{ width: 50 }}
          />

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Contas_Bancarias;
